import { get } from "svelte/store";
import { AvailabilityStatus } from "@workadventure/messages";
import { requestedStatusStore } from "../../Stores/MediaStore";
import { localUserStore } from "../../Connection/LocalUserStore";
import { popupStore } from "../../Stores/PopupStore";
import BubbleConfirmationModal from "../../Components/ActionBar/AvailabilityStatus/Modals/BubbleConfirmationModal.svelte";
import ChangeStatusConfirmationModal from "../../Components/ActionBar/AvailabilityStatus/Modals/ChangeStatusConfirmationModal.svelte";
import type { RequestedStatus } from "./statusRules";

export const askToChangeStatus = () => {
    popupStore.addPopup(ChangeStatusConfirmationModal, {}, "changeStatusConfirmationModal");
};

export const closeChangeStatusConfirmationModal = () => {
    popupStore.removePopup("changeStatusConfirmationModal");
};

export const hideBubbleConfirmationModal = () => {
    closeBubbleConfirmationModal();
};

export const resetAllStatusStoreExcept = (status: RequestedStatus | null = null) => {
    requestedStatusStore.set(status);
    localUserStore.setRequestedStatus(status);
};

// A player moving, triggering a map sprite/animation (e.g. the whip item), or an extension
// module reporting "back online" should never silently override a status the user picked on
// purpose (DO_NOT_DISTURB, BUSY). Only BACK_IN_A_MOMENT is meant to clear itself once the user
// is active again. Use this instead of resetAllStatusStoreExcept(null) for any automatic/script
// -triggered "back to online" signal; explicit user action (the status picker) must keep calling
// resetAllStatusStoreExcept directly so a deliberate "Online" click always wins.
export const softResetStatusToOnline = () => {
    const current = get(requestedStatusStore);
    if (current === AvailabilityStatus.DO_NOT_DISTURB || current === AvailabilityStatus.BUSY) {
        return;
    }
    resetAllStatusStoreExcept(null);
};

export const passStatusToOnline = () => {
    resetAllStatusStoreExcept();
    closeChangeStatusConfirmationModal();
    closeBubbleConfirmationModal();
};

export const closeBubbleConfirmationModal = () => {
    popupStore.removePopup("bubbleConfirmationModal");
};

export const askIfUserWantToJoinBubbleOf = (name: string) => {
    popupStore.addPopup(
        BubbleConfirmationModal,
        {
            name,
        },
        "bubbleConfirmationModal",
    );
};
